import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const closeIconStyles = {
  fontSize: '2.4rem',
  color: abyssColors.primary[500],
};

export const dialogStyles = {
  '.MuiDialog-container': {
    alignItems: 'baseline',
    paddingTop: '0',
  },
};

export const paperStyles = {
  maxWidth: '87rem',
  height: '66.3rem',
};

export const titleStyles = {
  padding: '3.2rem',
  paddingBottom: '2.4rem',
  typography: 'h4',
};

export const taskTabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content !important',
  paddingLeft: '2.4rem',

  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'auto',
    padding: '0.8rem 1.6rem',
    paddingBottom: '1.2rem',
    fontSize: '1.2rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 600,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    marginRight: '0.8rem',
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[700]} !important`,
    fontWeight: 600,
  },
  '& .MuiTab-textColorPrimary span': {
    color: abyssColors.primary[400],
    fontWeight: 600,
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[700],
    height: '0.4rem',
    zIndex: 2,
  },
};

export const taskItemsTabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content !important',
  marginTop: '1.6rem',
  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'auto',
    padding: '0.4rem 1.6rem',
    fontSize: '1.2rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 600,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    marginRight: '0.8rem',
    borderRadius: '0.4rem',
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 600,
    backgroundColor: abyssColors.primary[100],
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
};

export const textBoxStyles = {
  flex: 1,
  mt: '2.4rem',
  minHeight: 0,
  '& .MuiOutlinedInput-root': {
    height: '100%',
    padding: '1.6rem 2rem',
    fontSize: '1.4rem',
    lineHeight: 1.6,
    borderRadius: '0.4rem',
    alignItems: 'flex-start',
    '& fieldset': { border: '0.1rem solid #DDD' },
    '&:hover fieldset': { border: '0.1rem solid #DDD' },
    '&.Mui-focused fieldset': { border: '0.1rem solid #DDD' },
  },
  '& .MuiOutlinedInput-input': {
    padding: 0,
    height: '100% !important',
    overflowY: 'auto !important',
    boxSizing: 'border-box',
  },
};

export const ModalContent = muiStyled(Box)({
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '0rem 3.2rem 2.4rem 3.2rem',
  '& [role="tabpanel"]': {
    flex: '1 1 0',
    minHeight: 0,
    height: 'auto !important',
    display: 'flex',
    flexDirection: 'column',
  },
});
